var exports = {
  "AS": "xa15a2ab7--a42139--item",
  "Os": "xa15a2ab7--a42139--group",
  "Zq": "xa15a2ab7--a42139--group-commercial",
  "pG": "xa15a2ab7--a42139--right",
  "wx": "xa15a2ab7--a42139--header",
};

module.exports = exports;
